export default __webpack_public_path__ + "static/media/alerts-icon.a55c4a4d.svg";